<template >
  <div
    id="simulation-solagora"
    class="modal bd-example-modal-lg"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    ref="simulationSolAgora"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            id="close"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="clearForm()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            SIMULAÇÃO DE CRÉDITO SOL AGORA
          </h4>
        </div>

        <div class="modal-body" style="min-height: 24em">
          <Stepper
            :steps="this.steps"
            v-on:next="nextStep"
            v-on:previous="previousStep"
            v-model="this.currentStep"
          />

          <SimulationSolAgoraStep1
            v-if="this.currentStep === 1"
            :simulationData="this.simulationData"
            :precoEUP="this.precoEUP"
            v-on:updateSimulationData="updateSimulationData"
            v-on:updateParcela="updateParcela"
          />

          <SimulationSolAgoraStep2
            v-if="this.currentStep === 2"
            :simulationData="this.simulationData"
          />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            style="float: left; margin-bottom: 0.5em"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="clearForm()"
          >
            Cancelar
          </button>
          <button
                  type="button"
            v-if="currentStep > 1"
            aria-label="Anterior"
            style="margin-bottom: 0.5em"
            class="btn btn-primary"
            @click="previousStep()"
            :disabled="loader"
          >
            <i class="fa fa-chevron-left"></i> Anterior
          </button>
          <button
                  type="button"
            v-if="currentStep < lastStep && simulationData"
            aria-label="Próximo"
            style="margin-bottom: 0.5em"
            class="btn btn-primary"
            @click="nextStep()"
            :disabled="loader"
          >
            Próximo <i class="fa fa-chevron-right"></i>
          </button>
          <button
                  type="button"
            v-if="currentStep == 2"
            aria-label="Concluir"
            style="margin-bottom: 0.5em"
            class="btn btn-primary"
            @click="finalizar"
            :disabled="loader"
          >
            Concluir <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#simulation-solagora .modal-header {
  background: rgb(3, 124, 194);
  color: white;
}

.modal-header .modal-title {
  font-weight: bold;
  font-size: 14px;
}

.modal-header .close {
  color: white;
}
</style>

<script>
import Stepper from "@/components/Stepper";
import SimulationSolAgoraStep1 from "./SimulationSolAgoraStep1";
import SimulationSolAgoraStep2 from "./SimulationSolAgoraStep2";

const respostaPadraoErroGenerico =
  "Serviço indisponível, tente novamente mais tarde.";

export default {
  name: "SimulationSolAgora",
  props: {
    precoEUP: { type: Number, default: 0 },
  },
  components: {
    Stepper,
    SimulationSolAgoraStep1,
    SimulationSolAgoraStep2,
  },
  data() {
    return {
      loader: false,
      lastStep: 2,
      currentStep: 1,
      steps: [
        {
          step: 1,
          title: "Simulação",
        },
        {
          step: 2,
          title: "Resultado",
        },
      ],
      simulationData: null,
    };
  },
  methods: {
      nextStep() {
      switch (this.currentStep) {
        case 1: {
          if (!this.simulationData) return;
        }
      }

      if (this.currentStep < this.lastStep) this.currentStep++;

      switch (this.currentStep) {
        case 1:
          this.step1();
          break;
      }
    },

    previousStep(step = null) {
      if (step != null) {
        this.currentStep = step;
        return;
      }
      if (this.currentStep > 1) this.currentStep--;
    },

    updateSimulationData(simulationData) {
      this.simulationData = simulationData;
    },

    updateParcela(parcelaData) {
      this.simulationData = {
        ...this.simulationData,
        resultadoSimulacao: parcelaData.resultadoSimulacao,
      };
    },

    clearForm() {
      this.currentStep = 1;
      this.simulationData = null;
    },
    
    finalizar() {
      swal({
        title: "Parabéns sua simulação foi concluída!",
        icon: "success",
        button:
          "O próximo passo – Ao encerrar a negociação com o seu cliente, vá até o Carrinho para realizar o cadastro do seu cliente e submeter a análise de crédito.",
      }).then(() => {
        $("#close").trigger("click");
        this.clearForm();
      });
    },
  },
};
</script>